import { render, staticRenderFns } from "./orderbatch_refund.vue?vue&type=template&id=5316db54&scoped=true&"
import script from "./orderbatch_refund.vue?vue&type=script&lang=js&"
export * from "./orderbatch_refund.vue?vue&type=script&lang=js&"
import style0 from "./orderbatch_refund.vue?vue&type=style&index=0&id=5316db54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316db54",
  null
  
)

export default component.exports